import { GoodgameSignal } from "./GoodgameSignal";

/**
 *    NoneValueSignal
 *
 *     @author Alexander
 */

export class NoneValueSignal extends GoodgameSignal {
    constructor() {
        super();
    }

    public signal(): void {
        super.dispatch();
    }
}
